import { Validator } from '@vista-digital/validator';
import { JourneyActionButtonType } from '../../../types/type';
import { defaultJourneyActionButtonAppleWalletAssets, JourneyActionButtonAppleWalletAssetsValidator } from './assets';
import { defaultJourneyActionButtonAppleWalletDisplayText, journeyActionButtonAppleWalletDisplayTextValidator } from './display-text';
export const defaultJourneyActionButtonAppleWalletProps = {
    type: JourneyActionButtonType.AppleWallet,
    displayText: defaultJourneyActionButtonAppleWalletDisplayText,
    assets: defaultJourneyActionButtonAppleWalletAssets
};
export const journeyActionButtonAppleWalletPropsValidator = Validator.object({
    type: Validator.isEqualTo(JourneyActionButtonType.AppleWallet),
    displayText: journeyActionButtonAppleWalletDisplayTextValidator,
    assets: JourneyActionButtonAppleWalletAssetsValidator
});
